import { Conservator, UpdateHourlyRate } from './types';

export const MapViewToUpdateHourlyRate = (employee: Conservator): UpdateHourlyRate => ({
  conservator_id: employee.id,
  hourly_rate: employee.hourlyRate
});
